import styled from "styled-components";

const ButtonStyle = styled.button`
padding: ${props => props.padding};
color: ${props => props.color};
border-radius: ${props => props.borderRadius};
border: ${props => props.border};
font-size: ${props => props.fontSize};
background-color: ${props => props.backgroundColor};
margin: ${props => props.margin};
transition: 0.2s;
&:hover{
    background-color: ${props => props.hoverBackgroundColor};
    color: #333;
    transition: 0.2s;
}

`

const Button = ({children,margin, padding,color,borderRadius,hoverBackgroundColor,onClick,fontSize,border,backgroundColor,type, ...props}) =>{

    return(
        <ButtonStyle
         padding={padding}
         color={color}
         borderRadius={borderRadius}
         hoverBackgroundColor = {hoverBackgroundColor}
         fontSize={fontSize}
         border={border}
         backgroundColor={backgroundColor}
         onClick={onClick}
         type={type}
         margin='20px 0 0 0'
         {...props}
         >
            {children}
        
        </ButtonStyle>
        
    )
}

export default Button;